export const UNITED_TAGLINE = 'Be inspired. Be strong. Belong.';
export const UNITED_DESCRIPTION = `There is a light on your horizon. Joy, community, and the chance to change the world await. It all starts with you and a commitment to become your best self. To help others on their journey. To strive for more than the ordinary.

Join us on a quest composed of challenges where you will identify your own unique gifts, form connections with like-minded companions, and develop the resilience to build a life that matters.`;
export const UNITED_CTA = 'I’M READY';
export const UNITED_NAV_BAR_BUTTON_TEXT = 'Take the Quiz';
export const UNITED_CLIFFHANGER = 'Are you ready for more?';
